<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import NotificationBell from './NotificationBell.vue';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    NotificationBell,
  },
  props: {
    logoThumbnail: { type: String, required: true },
    logoThumbnailDark: { type: String, required: true },
    installationName: { type: String, default: '' },
    accountId: { type: Number, default: 0 },
    menuItems: { type: Array, default: () => [] },
    activeMenuItem: { type: String, default: '' },
    internalChatUnreadCount: { type: Number, default: 0 },
  },
  methods: {
    openNotificationPanel() {
      this.$emit('openNotificationPanel');
    },
    primaryNavBadge(menuItem) {
      if (menuItem.key !== 'internal_chat') return '';
      const n = this.internalChatUnreadCount;
      if (!n || n < 1) return '';
      return n > 99 ? '99+' : String(n);
    },
  },
};
</script>

<template>
  <div
    class="bg-custom border-r border-slate-50 dark:border-slate-800/50 rtl:border-l rtl:border-r-0 flex justify-between flex-col"
  >
    <div class="flex flex-col items-center">
      <Logo
        :logo-thumbnail="logoThumbnail"
        :logo-thumbnail-dark="logoThumbnailDark"
        :name="installationName"
        :account-id="accountId"
      />
      <PrimaryNavItem
        v-for="menuItem in menuItems"
        :key="menuItem.toState"
        :icon="menuItem.icon"
        :name="menuItem.label"
        :to="menuItem.toState"
        :count="primaryNavBadge(menuItem)"
        :is-child-menu-active="menuItem.key === activeMenuItem"
      />
    </div>
    <div class="flex flex-col items-center justify-end pb-6">
      <NotificationBell @open-notification-panel="openNotificationPanel" />
    </div>
  </div>
</template>

<style scoped>
.bg-custom {
  width: 92px;
  height: auto;
  flex-shrink: 0;
  background-color: #fff;
}
</style>
